import React, { FC } from 'react';
import { TrendsDetailTable } from './components/TrendsDetailTable';
import { ITrendsDetailTableProps } from './types';

const TrendsDetail: FC<ITrendsDetailTableProps> = props => <TrendsDetailTable {...props} />;
export default TrendsDetail;
